import { render } from "./replies-item.vue?vue&type=template&id=c1a2ea1e&scoped=true&ts=true"
import script from "./replies-item.vue?vue&type=script&lang=ts"
export * from "./replies-item.vue?vue&type=script&lang=ts"

import "./replies-item.vue?vue&type=style&index=0&id=c1a2ea1e&lang=scss&scoped=true"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1a2ea1e"]])

export default __exports__